package org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.hardware.tse_location


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CashAssist(
    @SerialName("getShop")
    val getShop: GetShop?,
    @SerialName("__typename")
    val typename: String?
)